import React from "react";
import { Grid, Button } from "@mui/material";
import styled from "styled-components";
import { Code as CodeIcon, PictureAsPdf as PdfIcon } from "@mui/icons-material";

const CustomButton = styled(Button)`
  width: 100%;
  padding-top: 15px !important;
  padding-bottom: 15px !important;
  .MuiButton-label {
    color: white;
    font-size: 14px;
    text-transform: none;
    line-height: 19px;
    font-weight: 400;
    .MuiButton-startIcon {
      width: 20px;
    }
  }
  &.Mui-disabled {
    .MuiButton-label {
      color: #a0a0a0 !important;
    }
  }
  &.Mui-success {
    color: #15c67d !important;
    .MuiButton-label {
      color: #15c67d !important;
    }
  }
`;
const CustomButtonWithBorder = styled(CustomButton)`
  border-right: 1px solid gray !important;
  border-radius: 0 !important;
`;
const Wrapper = styled(Grid)`
  border-top: 1px solid gray;
`;

// TO DO - load map preview
const Bottom = (props) => {
  const { onExportXML, onExportPDF } = props;

  return (
    <Wrapper container>
      <Grid item xs={6}>
        <CustomButtonWithBorder
          startIcon={<CodeIcon />}
          disabled={true}
          onClick={onExportXML}
        >
          Export XML
        </CustomButtonWithBorder>
      </Grid>
      <Grid item xs={6}>
        <CustomButton
          startIcon={<PdfIcon />}
          disabled={true}
          onClick={onExportPDF}
        >
          Export PDF
        </CustomButton>
      </Grid>
    </Wrapper>
  );
};

export default Bottom;
